import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'
import { Builder } from 'views/Canvas/Builder'
import { JsonFlowEditor } from 'views/JsonFlowEditor'
import {
  BuilderElementType,
  CloudData,
  FintalkCloudContextState,
  Props,
} from './types'

import { BuilderContextProvider } from 'contexts/Builder'
import { useFintalkCloudSidebarItems } from 'utils/hooks/useFintalkCloudSidebarItems'

const FintalkCloudContext = createContext<FintalkCloudContextState>(
  {} as FintalkCloudContextState,
)

export function FintalkCloudContextProvider({ children, history }: Props) {
  const { builderSidebarOptions } = useFintalkCloudSidebarItems()

  const currentElementName = 'builder'

  const currentSidebar = builderSidebarOptions

  const [currentData, setCurrentData] = useState<CloudData>({
    companyName: '',
    projectName: '',
    agentName: '',
    groupName: '',
    blockName: '',
    isEditing: false,
    exportAgent: false,
    importAgent: false,
    permissions: [],
  })

  const [builderElementToOpen, setBuilderElementToOpen] = useState<
    BuilderElementType | undefined
  >(undefined)

  const getCurrentElement = {
    builder: (
      <BuilderContextProvider>
        <Builder history={history} />
      </BuilderContextProvider>
    ),
    jsonFlowEditor: <JsonFlowEditor />,
  }

  const loadLocalData = useCallback((event: MessageEvent) => {
    /* const allowedOrigin = '';

    if (event.origin !== allowedOrigin) {
      console.warn('Mensagem recebida de origem não permitida:', event.origin);
      return;
    } */

    if (!event.data || event.data.type !== 'STUDIO_DATA') {
      console.warn('Mensagem recebida inválida:', event.data)
      return
    }

    const {
      companyName,
      companyId,
      projectName,
      agentName,
      agentId,
      groupName,
      blockName,
      token,
      permissions,
    } = event.data.data

    localStorage.setItem('@studio:user_access_token', token)
    localStorage.setItem('@studio:agent_id', agentId)
    localStorage.setItem('@studio:company_id', companyId)

    setCurrentData((prev) => ({
      ...prev,
      companyName: companyName ?? prev.companyName,
      projectName: projectName ?? prev.projectName,
      agentName: agentName ?? prev.agentName,
      groupName: groupName ?? prev.groupName,
      blockName: blockName ?? prev.blockName,
      permissions: permissions || [],
    }))
  }, [])

  useEffect(() => {
    window.parent.postMessage({ type: 'BUILDER_READY' }, '*')

    window.addEventListener('message', loadLocalData)

    return () => {
      window.removeEventListener('message', loadLocalData)
    }
  }, [loadLocalData])

  return (
    <FintalkCloudContext.Provider
      value={{
        getCurrentElement,
        currentElementName,
        currentSidebar,
        currentData,
        builderElementToOpen,
        setCurrentData,
        setBuilderElementToOpen,
      }}
    >
      {children}
    </FintalkCloudContext.Provider>
  )
}

export function useFintalkCloud() {
  const context = useContext(FintalkCloudContext)
  return context
}
